import React, { useEffect } from "react";
import HeaderTransprent from "../../components/HeaderTransprent.js"
import Footer from "../../components/Footer.js";
import ContactForm from "../../components/ui/ContactForm.js";
// import { GoMail } from "react-icons/go";
// import { TbBuilding } from "react-icons/tb";

const ContactUs = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>

      <div className="">
        <HeaderTransprent />
        <section className="bg-cover bg-no-repeat bg-right w-full h-96 flex items-center justify-center text-center" style={{ backgroundImage: `url('/img/assets/home/contact-us.webp')`, }}>
          <div className="px-4">
            <div data-aos="fade-up">
              <h1 className="xl:text-6xl text-5xl leading-[3rem] xl:leading-[3.5rem] font-bold text-white capitalize">
                Let’s Connect
              </h1>
            </div>
          </div>
        </section>


        <ContactForm />

        <Footer />
      </div>
    </>
  );
}


ContactUs.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};


export default ContactUs;
